import {StaticEnvironment} from '@forlabs/api-bridge';


export const staticEnvironment: StaticEnvironment = {
  production: true,
};
